// Copyright (c) StrangeBee 2024

import { classList } from '@Helpers/className';
import { Radio } from 'antd';
import { RadioButtonProps } from 'antd/lib/radio/radioButton';
import React from 'react';

import './Button.scss';

type ButtonProps = RadioButtonProps;

export const Button = ({ className, ...props }: ButtonProps) => {
    return <Radio.Button className={classList('th-radio__button', className)} {...props} />;
};
